(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["color-swatch-references"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.color-swatch-references__toggle');
    if (!toggle) return;
    const container = toggle.closest('.color-swatch-references');
    if (!container) return;
    const expanded = container.classList.toggle('color-swatch-references--expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute(
      'aria-label',
      expanded ? 'Show fewer colors' : 'Show all colors'
    );
  });
  } catch(e) { console.error(e); }
})();

})();
